import type { auth as pt } from '../pt/auth';
// English mirror of ../pt/auth.ts (shape checked against its pt twin).
export const auth: typeof pt = {
  login: {
    logoAlt: 'Logo',
    subtitle: 'Management area — please sign in.',
    configLoadError: 'Could not load the configuration; showing the default options.',
    signInFailed: 'Could not sign in.',
    urlError: 'Could not sign in. Please try again or contact support.',
    entraButton: 'Sign in with Microsoft 365',
    localDivider: 'or local account (staging)',
    username: 'Username',
    password: 'Password',
    signIn: 'Sign in',
    signingIn: 'Signing in…',
  },
  iamnew: {
    needInvite: 'This form requires an invitation. Ask the CIIMAR team for a link.',
    inviteInvalid: 'The invitation is not valid or has expired.',
    submitError: 'Something went wrong. Please try again.',
    validating: 'Validating the invitation…',
    unavailableTitle: 'Invitation unavailable',
    doneTitle: 'Thank you!',
    doneBody:
      'Your registration has been submitted and will be reviewed by the CIIMAR onboarding team. If any information needs adjusting, you will be contacted by email.',
    title: 'New member registration — CIIMAR',
    invitedBy: 'Invited by {name}. ',
    fillIn: 'Fill in your details. Fields marked with * are required.',
    fullName: 'Full name *',
    email: 'Email *',
    phone: 'Phone',
    startDate: 'Start date',
    jobTitle: 'Role / position',
    department: 'Department',
    researchGroup: 'Research group',
    notes: 'Notes',
    extraTitle: 'Additional information',
    submit: 'Submit registration',
    submitting: 'Submitting…',
  },
  landing: {
    title: 'Registration — CIIMAR',
    subtitle: 'Starting at CIIMAR? Enter the code you were given.',
    codeLabel: 'Registration code',
    codePlaceholder: 'e.g. ABCD2345',
    continue: 'Continue',
    memberPrompt: 'Are you a CIIMAR member?',
    enterPortal: 'Enter the Portal',
  },
};
